var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inviteMemberError)?_c('invite-member-error'):_c('server-error')}
var staticRenderFns = []

export { render, staticRenderFns }